/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ComponentRendering,
  Item,
  LinkField,
  TextField,
  useSitecore,
} from '@sitecore-content-sdk/nextjs';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { format } from 'date-fns';
import { Data } from '.generated/Foundation.CW.model';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import Link from 'next/link';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { JSX } from 'react';
import { useSiteSettings } from 'lib/utils/page-data-static-props/pageDataContext';
import { CoveoFacetFields } from 'lib/constants';

export type BlogDetailHeaderProps = Data.BaseTemplateSections.Blog;

interface BlogDetailHeaderComponentProps extends BlogDetailHeaderProps {
  rendering: ComponentRendering;
  params?: { DynamicPlaceholderId?: string };
}

const BlogDetailHeader = (_props: BlogDetailHeaderComponentProps): JSX.Element => {
  const { page } = useSitecore();
  const route = page?.layout?.sitecore?.route as BlogDetailHeaderProps;
  const dateString = route?.fields?.date?.value;
  console.log('dateString', dateString);
  const formattedDate = (dateString?: string) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    return format(date, 'MMM dd, yyyy');
  };

  console.log('dateString & formattedDate:', dateString, formattedDate);
  const authorItem = route?.fields?.author as Item;
  const authorLink = authorItem?.fields?.authorPageLink as LinkField;
  const authorName = authorItem?.fields?.authorName as TextField;
  const authorTitle = authorItem?.fields?.authorTitle as TextField;
  const siteSettings = useSiteSettings()?.fields;
  const blogSearchPage = siteSettings?.blogSearchPage as LinkField;

  const { DynamicPlaceholderId } = _props?.params || {};
  const phKey = `socialsharelinks-${DynamicPlaceholderId}`;

  return (
    <section role="region" className="bg-white flex flex-col-reverse lg:block">
      <div className="w-full max-w-screen-xxl mx-auto lg:px-[80px] lg:relative lg:z-[9] ">
        <ImageWrapper
          field={route?.fields?.heroImage}
          className="aspect-[7/4] w-full lg:rounded-lg object-cover"
          priority={true}
        />
      </div>
      <div
        className={`bg-blue-50 lg:relative lg:z-[8] ${route?.fields?.heroImage?.value?.src ? 'lg:-mt-16' : ''}`}
      >
        <div className="max-w-screen-xxl mx-auto py-[32px] px-10 lg:px-[80px] lg:py-[80px] lg:pb-[64px]">
          <Link
            href={`${blogSearchPage?.value?.href}?${CoveoFacetFields.blogContentType}=${route?.fields?.blogContentType?.value}`}
            prefetch={false}
            className="!text-blue-700 w-fit flex-row theme-text-btn border-theme-text-btn-border lg:flex inline font-bold font-centuryGothic gap-x-4 items-center justify-center  !text-14 !leading-22 rounded-sm lg:text-center text-left text-theme-text-btn-text active:bg-theme-text-btn-hover active:text-theme-text-btn-hover-text active:border-theme-text-btn-hover-border  focus:outline-offset-2 focus:outline-2 focus:outline-theme-text-btn-outline focus:border-theme-text-btn-border focus:outline hover:!text-darkblue-base pb-2"
          >
            <PlainTextWrapper field={route?.fields?.blogContentType} />
          </Link>

          <h1 className="text-gray-900 lg:text-48 text-[40px] leading-[48px] lg:leading-[58px] font-bold font-centuryGothic py-[24px]">
            <PlainTextWrapper field={route?.fields?.blogPostTitle} />
          </h1>
          <div className="lg:flex justify-between items-center w-full ">
            {/* Author and date content  */}
            <div className="pb-[24px] lg:pb-0">
              <div className="flex gap-[24px] text-16 leading-25 text-gray-900 font-nunitoSans mb-[16px]">
                <div className="">
                  <PlainTextWrapper field={route?.fields?.readTimeLabel} />
                </div>
                <div>{formattedDate(dateString)}</div>
              </div>
              <div className="flex justify-between items-center w-full">
                <div className="text-16 leading-25 font-nunitoSans flex gap-[8px] text-[#111]">
                  <LinkWrapper
                    field={authorLink}
                    className={`!p-0 font-bold !text-blue-700 !text-16 !leading-25 ${authorLink?.value?.href !== '' && 'hover:!text-darkblue-base hover:cursor-pointer hover:!underline'}`}
                    ctaVariant="tertiary"
                    aria-label={authorName?.value as string}
                  >
                    <PlainTextWrapper field={authorName} />
                  </LinkWrapper>
                  {authorName?.value && authorTitle?.value && (
                    <div className="bg-black h-[14px] w-[5px]">|</div>
                  )}
                  <div>
                    <PlainTextWrapper field={authorTitle} />
                  </div>
                </div>
              </div>
            </div>
            {/* Social share content  */}
            <div>
              <PlaceholderWrapper name={phKey} rendering={_props.rendering} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailHeader;
